<template>
  <div
    id="app"
    flex="dir:top">
    <div style="padding: 40px;flex-grow: 1;overflow: unset;">
      <div
        class="pesudo-box"
        @click="toLogin">
        <div
          class="pesudo"
          flex-box="0">
          登录
        </div>
      </div>
      <main>
        <el-form
          ref="shortForm"
          inline
          :rules="rules"
          :model="form"
          label-position="top"
          label-width="80px">
          <el-form-item
            class="form50"
            label="载体"
            prop="type">
            <el-select
              v-model="form.type"
              placeholder="请选择载体">
              <el-option
                label="无载体"
                value=""></el-option>
              <el-option
                label="图片展示"
                value="img"></el-option>
              <el-option
                label="手机号检测"
                value="phone"></el-option>
              <el-option
                label="微信检测"
                value="wx"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="form50 project"
            label="短链项目"
            prop="projectId">
            <el-select
              v-model="form.projectId"
              clearable
              placeholder="请选择一个项目">
              <el-option
                v-for="item in projectList"
                :key="item.projectId"
                :label="item.projectName"
                :value="item.projectId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="org-item"
            prop="inputMode">
            <el-radio-group
              v-model="inputMode"
              style="margin-bottom: 10px;">
              <el-radio-button label="link">
                链接
              </el-radio-button>
              <el-radio-button label="image">
                图片
              </el-radio-button>
            </el-radio-group>
            <el-input
              v-if="inputMode === 'link'"
              v-model="form.orgUrl"
              class="org-input"
              placeholder="请输入 http:// 或 https:// 开头的网址"></el-input>
            <el-upload
              v-if="inputMode === 'image'"
              class="avatar-uploader"
              :limit="1"
              action=""
              :show-file-list="false"
              :http-request="beforeAvatarUpload">
              <img
                v-if="form.orgUrl"
                :src="form.orgUrl"
                class="avatar" />
              <i
                v-else
                class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item
            label="标签"
            class="tags"
            prop="tags">
            <el-input
              v-model="form.tags"
              placeholder="请输入标签，多个标签使用逗号隔开"></el-input>
          </el-form-item>
          <el-form-item
            style="margin-bottom: 10px;"
            label="描述"
            class="tags"
            prop="rem">
            <el-input
              v-model="form.rem"
              placeholder="请输入描述"></el-input>
          </el-form-item>
          <el-form-item style="text-align: center;width: 100%;">
            <el-button
              class="form-btn"
              type="primary"
              @click="onSubmit">
              生成短链接
            </el-button>
            <el-button
              class="form-btn reset"
              @click="resetForm">
              重置
            </el-button>
          </el-form-item>
        </el-form>
      </main>
      <div
        v-if="result"
        class="footer-card">
        <short-link-card :item="result"></short-link-card>
      </div>
    </div>
    <footer>
      <div class="footer-content">
        <div class="copyright">
          ©2025 ******** 版权所有
        </div>
        <div class="beian">
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank">粤ICP备2025492946号-1</a>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import {createShortLink, getShortUrlProjectList, uploadAction} from "service";
import shortLinkCard from '@c/shortLinkCard.vue';
export default {
  name: 'App',
  components: {
    shortLinkCard
  },
  data() {
    var validateUrl = (rule, value, callback) => {
      if (this.inputMode === 'image') {
        callback();
        return;
      }
      if (value === '') {
        callback(new Error('请输入跳转链接'));
      } else if (!/^(https?:\/\/)/.test(value)) {
        callback(new Error('请输入 http:// 或 https:// 开头的网址'));
      } else {
        callback();
      }
    };
    return {
      size: 500,
      inputMode: 'link',
      form: {
        orgUrl: '',
        tags: '',
        projectId: '',
        rem: '',
        type: ''
      },
      rules: {
        orgUrl: [
          { validator: validateUrl, trigger: 'blur' }
        ],
        projectId: [
          { required: true, message: '请选择短链项目', trigger: 'change' }
        ]
      },
      projectList: [],
      result: null
    };
  },
  created() {
    getShortUrlProjectList().then(resp => {
      this.projectList = resp.data.list;
      this.form.projectId = resp.data.defaultProjectId;
    });
  },
  watch: {
    inputMode() {
      this.form.orgUrl = '';
    }
  },
  methods: {
    beforeAvatarUpload({ file }) {
      const isLt5K = (file.size / 1024 / 1024) < (this.size / 1000);
      if (!isLt5K) {
        this.$message.error(`上传图片大小不能超过 ${(this.size / 1000).toFixed(2).replace(/0+$/g, "")}M!`);
        return false;
      }

      let fd = new FormData();
      let key = "shortUrl/" + this.generateRandomString() + Date.now() + file.type.replace(/^.*\//, '.');
      fd.append("file", file);
      fd.append("fileKey", "" + key);
      uploadAction(fd).then(resp => {
        let data = resp.data.data;
        this.form.orgUrl = data.fileUrl;
      }).catch(e => {
        this.$message.error("上传失败：" + e);
      });
    },

    generateRandomString(length = 6) {
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let result = '';
      for (let i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return result;
    },

    toLogin() {
      window.location.href = (process.env.VUE_APP_API || window.location.origin) + "/swiftlogin.html";
    },

    onSubmit() {
      this.result = null;
      this.submitForm();
    },

    submitForm() {
      this.$refs.shortForm.validate((valid) => {
        if (valid) {
          if (this.inputMode === 'image' && !this.form.orgUrl) {
            this.$message.error("请上传图片");
            return;
          }
          if (this.inputMode === 'link' && !this.form.orgUrl) {
            this.$message.error("请输入链接");
            return;
          }

          let submitData = {
            orgUrl: this.form.orgUrl,
            projectId: this.form.projectId
          };
          if (this.form.type) {
            submitData.type = this.form.type;
          }
          if (this.form.tags) {
            submitData.tags = this.form.tags;
          }
          if (this.form.rem) {
            submitData.rem = this.form.rem;
          }
          submitData.curDoamin = window.location.hostname;
          createShortLink(submitData).then(resp => {
            this.$message.success(resp.reason || "生成短链成功");
            this.result = resp.data;
          });
        } else {
          this.$message.error("请检查表单");
          return false;
        }
      });
    },

    resetForm() {
      this.$refs.shortForm.resetFields();
      this.inputMode = 'link';
      this.result = null;
    }
  },
};
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px !important;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
</style>
<style lang="scss">
#app{
  background-color: #f5f7fa;
  background-image: url("assets/images/index_bg.png");
  background-repeat: no-repeat;
  background-position: 50% 294px;
  width: 100vw;
  height: 100vh;
  overflow: scroll;
}

.pesudo-box{
  margin-right: 0;
  margin-left: auto;
  width: 80px;
  height: 40px;
  background-color: #fff;
  text-align: center;
  line-height: 40px;
  border-radius: 5px;
  margin-bottom: 20px;
  box-shadow: 0px 20px 50px 0px rgba(18,98,179,0.1);
  transition: margin 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  &:hover{
    cursor: pointer;
  }
}
.pesudo {
    box-shadow: unset;
}
main{
  background-color: #fff;
  box-shadow: 0px 20px 50px 0px rgba(18,98,179,0.1);
  padding: 30px;
  margin: 0 auto 40px;
  max-width: 1000px;
  min-width: 700px;
  .el-form{
    display: flex !important;
    flex-wrap: wrap;
  }
  .el-radio{
    margin-right: 8px;
  }
  .is-required,.org-item{
    .el-form-item__label{
      &::before{
        display: none;
      }
      &::after{
        content:"*"
      }
    }
  }
  .org-item{
    width: 100%;
    flex-shrink: 1;
  }
  .project{
    flex-shrink: 0;
    .el-form-item__label{
      width: auto !important;
      padding-right: 16px;
      font-size: 16px;
    }
  }
  .tags{
    width: 100%;
    flex-shrink: 0;
  }
  .form50{
    width: auto;
    flex-shrink: 1;
    display: flex !important;
    .el-form-item__label{
      width: auto !important;
      padding-right: 16px;
      font-size: 16px;
    }
  }
  .el-input{
    .el-input__inner{
      font-family: MicrosoftYaHeiUI;
      font-size: 14px;
      color: #606266;
      letter-spacing: 0;
      line-height: 14px;
      font-weight: 400;
    }
  }
  .org-input{
    height: 60px;
    .el-input__inner{
      height: 60px;
      font-weight: 900;
    }
  }
  .form-btn{
    width: 140px;
    height: 54px;
    font-family: MicrosoftYaHeiUI-Bold;
    font-size: 16px;
    color: #FFFFFF;
    letter-spacing: 0;
    line-height: 14px;
    font-weight: 700;
  }
  .form-btn.reset{
    color: #606266;
  }
}
.footer-card{
  min-width: 700px;
  box-shadow: 0px 20px 50px 0px rgba(18,98,179,0.1);
  background-color: #fff;
}
</style>
<style>
 footer {
    flex-shrink: 0;
    background: #333;
    color: white;
    text-align: center;
    padding: 20px 0;
    font-family: Arial, sans-serif;
  }
  .footer-content {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .copyright {
    font-size: 14px;
  }
  .beian {
    font-size: 13px;
  }
  .beian a {
    color: #aaa;
    text-decoration: none;
  }
  .beian a:hover {
    text-decoration: underline;
  }
</style>
